import { sumPricingInfo } from 'pricing-pages-lib/utils/pricingUtils';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { PriceDisplayStyled } from 'pricing-pages-ui-components/price/PriceDisplayStyled';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { usePurchaseableProductsForTerm } from '../../../hooks/useBulkPurchaseOptions';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import { usePriceForQuantityPackQuantity } from '../../../hooks/usePagedQuantityPacks';
import { useAppSelector } from '../../../reducers';
import { isUngatedForSeatsSelector } from '../../../selectors/GatingSelectors';
import { showPricePerMonthPerSeatSelector } from '../../../selectors/MerchCardSelectors';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import IncludedSeatsDisplay from '../IncludedSeatsDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HighlightedMerchPriceDisplay = ({
  skuId,
  queryParamTerm,
  quantityPackSkuId,
  quantityPackQuantity,
  nonMerchandiseIdProduct,
  apiName,
  quantityPackApiName,
  setIsLoadingQuantityPacks
}) => {
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  const isAppReady = useGlobalLoading();

  // Only pre-seats merch cards will factor in quantity pack pricing since they
  // still have quantity pack steppers directly on the cards
  const shouldFactorQuantityPacksIntoPrice = !isUngatedForSeats;
  const productConfigurations = [createProductConfig({
    skuId
  })];
  if (shouldFactorQuantityPacksIntoPrice && quantityPackSkuId && quantityPackQuantity && quantityPackQuantity > 0) productConfigurations.push(createProductConfig({
    skuId: quantityPackSkuId,
    quantity: quantityPackQuantity
  }));
  const {
    purchaseOptionsForTerm,
    loading: purchaseOptionsForTermLoading
  } = usePurchaseableProductsForTerm({
    queryParamTerm,
    apiName
  });
  const {
    quantityPackPrice,
    loading: quantityPackPriceLoading
  } = usePriceForQuantityPackQuantity({
    productApiName: apiName,
    quantityPackApiName: shouldFactorQuantityPacksIntoPrice ? quantityPackApiName : undefined,
    additionalQuantity: quantityPackQuantity || 0,
    queryParamTerm
  });
  const loading = purchaseOptionsForTermLoading || quantityPackPriceLoading;
  useEffect(() => {
    if (setIsLoadingQuantityPacks) {
      setIsLoadingQuantityPacks(quantityPackPriceLoading);
    }
  }, [quantityPackPriceLoading, setIsLoadingQuantityPacks]);
  const purchaseOptionsPriceSum = sumPricingInfo([purchaseOptionsForTerm, quantityPackPrice]);
  const showPricePerMonthPerSeat = useSelector(state => {
    if (!isAppReady) {
      return false;
    }
    return showPricePerMonthPerSeatSelector(state, {
      skuId
    });
  });
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  if (!purchaseOptionsPriceSum && !loading) {
    return null;
  }
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [20, 33],
    widths: [60, 80],
    children: purchaseOptionsPriceSum && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PriceDisplayStyled, {
        pricingInfo: purchaseOptionsPriceSum,
        showPricePerMonthPerSeat: showPricePerMonthPerSeat,
        seleniumId: apiName || nonMerchandiseIdProduct || 'loading',
        currencyCode: currencyCode,
        currencyCodeUnit: currencyCodeUnit
      }), /*#__PURE__*/_jsx(IncludedSeatsDisplay, {
        skuId: skuId,
        quantityPackSkuId: quantityPackSkuId,
        quantityPackQuantity: quantityPackQuantity,
        queryParamTerm: queryParamTerm
      })]
    })
  });
};
export default HighlightedMerchPriceDisplay;